import React, { useReducer, useState } from "react";
import SoftwareSoldFilterBar from "./SoftwareSoldFilterBar";
import SoftwareSoldOptionsBar from "./SoftwareSoldOptionsBar";
import { Item } from "../../utils/sharedTypes";
import { SoftwareSoldItemFilter } from "./softwareSoldTypes";
import SoftwareSoldTable from "./SoftwareSoldTable";
import ModulesManagementButton from "../modules/ModulesManagementButton";
import { Grid } from "@mui/material";
import ImportButton from "../import-licenses/ImportButton";

const initialFilters: SoftwareSoldItemFilter = {
  company: null,
  hardwareType: null,
  serial: "",
  software: null,
  soldDateFrom: "",
  soldDateTo: "",
  supportStartTo: "",
  supportStartFrom: "",
  supportStatus: "",
};

const SoftwareSold = () => {
  const [filters, setFilters] = useReducer(
    (curVals: SoftwareSoldItemFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedSoftware, setSelectedSoftware] = useState<Item[]>([]);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <>
      <SoftwareSoldFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container spacing={1}>
        <Grid item>
          <SoftwareSoldOptionsBar
            selectedSoftware={selectedSoftware}
            setSelectedSoftware={setSelectedSoftware}
            editModalOpenFlag={editModalOpenFlag}
            setEditModalOpenFlag={setEditModalOpenFlag}
          />
        </Grid>
        <Grid item>
          <ModulesManagementButton />
        </Grid>
        <Grid item>
          <ImportButton />
        </Grid>
      </Grid>
      <SoftwareSoldTable
        setSelectedSoftware={setSelectedSoftware}
        filters={filters}
        setEditModalOpenFlag={setEditModalOpenFlag}
      />
    </>
  );
};

export default SoftwareSold;
